import React from 'react';
import PropTypes from 'prop-types';
import Select2 from "shared/react_components/Select2/index";
import FieldError from "./FieldError";

export default class AdvertiserCampaignSelect extends React.Component {
  render() {
    const { errorMessages, advertiserCampaignLabel } = this.props;
    const fieldErrors = errorMessages.map((error) => <FieldError errorMessage={error} key={error} />);
    const validationClass = fieldErrors.length > 0 ? "sb-field-group--invalid" : "";

    return (
      <div className={`sb-field-group ${validationClass}`} data-mount="advertiser_campaign_id">
        <label className="sb-field-label">{advertiserCampaignLabel}</label>
        <div data-mount="advertiser-campaign-area">
          <Select2 {...this.selectArgs()} />
        </div>
        <span id="advertiser_campaign_fixed"></span>
        {fieldErrors}
      </div>
    );
  }

  selectArgs() {
    const { friendlyNameField, uniqueNameField, destinationCampaign, allowSearch, changeListener } = this.props;

    return {
      friendlyNameField,
      uniqueNameField,
      allowSearch,
      changeListener,
      url:    destinationCampaign.advertiserCampaignUrl,
      node:   destinationCampaign,
      width:  "400px"
    };
  }

  static propTypes = {
    advertiserCampaignLabel:  PropTypes.string,
    friendlyNameField:        PropTypes.string,
    uniqueNameField:          PropTypes.string,
    allowSearch:              PropTypes.bool,
    destinationCampaign:      PropTypes.object,
    changeListener:           PropTypes.func,
    errorMessages:            PropTypes.array
  };

  static defaultProps = {
    uniqueNameField:          "0",
    friendlyNameField:        "text",
    allowSearch:              true,
    advertiserCampaignLabel:  "Campaign",
    errorMessages:            []
  };
}
